module.exports = __webpack_public_path__ + "static/media/avatar_bunny.4fe7715b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_bunny.png
// module id = 369
// module chunks = 0